import React from 'react'
import { Text } from 'react-native'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import { SUBHEADING_STYLES, TEXT_STYLES } from '@dehaat/dds'

import { ROUTES as FARMER_360_ROUTES } from 'app/farmer360/routes/types'
import { backHandler } from 'app/utils/common'

import { RootStackParamList, ROUTES } from './types'
import { routesFarmer360, routesKhetedge } from './Routes'
import { useTranslation } from 'react-i18next'

import HeaderMenu from 'app/components/HeaderMenu'
import Dashboard from 'app/screens/dashboard'
import CustomBackButton from 'app/components/reusable/CustomBackButton'
import { initMixpanel } from 'app/farmer360/utils/mixpanel'
import AuthToken from 'app/models/Auth'
import { getCookies } from 'app/utils/storage'
import PriceRequest from 'app/screens/PriceRequest'
import RequestType from 'app/screens/RequestType'
import DemoMaterialRequest from 'app/screens/DemoMaterialRequest'
import NewRequest from 'app/screens/NewRequest'
import ChangePriceScreen from 'app/screens/ChangePriceScreen'
import RequestSuccessScreen from 'app/screens/RequestSuccessScreen'
import DemoProductSelection from '../screens/DemoProductSelection'
import DemoCreateRequest from '../screens/DemoCreateRequest'
import DemoReviewRequest from '../screens/DemoReviewRequest'
import DemoRequestDetail from '../screens/DemoRequestDetail'

const RootStack = createNativeStackNavigator<RootStackParamList>()

initMixpanel()

export const RootStackNavigator = () => {
  const { t } = useTranslation()
  const cookies = getCookies<AuthToken>()
  const isFromAIMSApp = getCookies().appCode && getCookies().fromApp

  const localizedScreenTitle = (titleKey?: string) =>
    titleKey ? t(titleKey) : undefined

  return (
    <RootStack.Navigator
      initialRouteName={ROUTES.DASHBOARD}
      screenOptions={() => {
        return {
          headerLeft: () => <CustomBackButton onBackPress={backHandler} />,
          headerBackVisible: false,
          headerRight: () => <HeaderMenu />,
          headerTitle: ({ children }) => (
            <Text
              style={[SUBHEADING_STYLES.MEDIUM_S3, TEXT_STYLES.textNeutral90]}
            >
              {children}
            </Text>
          ),
          animation: 'none',
        }
      }}
    >
      <RootStack.Screen
        name={ROUTES.DASHBOARD}
        component={Dashboard}
        options={{ headerShown: false }}
      />
      <RootStack.Screen
        name={ROUTES.REQUEST_TYPE}
        component={RequestType}
        options={{
          title: 'Request Type',
          headerShown: isFromAIMSApp ? false : true,
          headerRight: () => null,
        }}
      />
      <RootStack.Screen
        name={ROUTES.PRICE_REQUEST}
        component={PriceRequest}
        options={{
          title: 'Change Requests',
          headerShown: isFromAIMSApp ? false : true,
          headerRight: () => null,
        }}
      />
      <RootStack.Screen
        name={ROUTES.DEMO_MATERIAL_REQUEST}
        component={DemoMaterialRequest}
        options={{
          title: 'Demo Material Issue',
          headerShown: isFromAIMSApp ? false : true,
          headerRight: () => null,
        }}
      />
      <RootStack.Screen
        name={ROUTES.NEW_REQUEST}
        component={NewRequest}
        options={{
          title: 'Select DC/MDC (New Request)',
          headerRight: () => null,
        }}
      />
      <RootStack.Screen
        name={ROUTES.CHANGE_PRICE}
        component={ChangePriceScreen}
        options={{
          title: 'Change Selling Price',
          headerRight: () => null,
        }}
      />
      <RootStack.Screen
        name={ROUTES.REQUEST_SUCCESS}
        component={RequestSuccessScreen}
        options={{ headerShown: false }}
      />
      <RootStack.Screen
        name={ROUTES.DEMO_PRODUCT_SELECTION}
        component={DemoProductSelection}
        options={{
          title: 'Select Product Variant',
          headerRight: () => null,
          gestureEnabled: false,
        }}
      />
      <RootStack.Screen
        name={ROUTES.DEMO_CREATE_REQUEST}
        component={DemoCreateRequest}
        options={{
          title: 'Create Request',
          headerRight: () => null,
          gestureEnabled: false,
        }}
      />
      <RootStack.Screen
        name={ROUTES.DEMO_REVIEW_REQUEST}
        component={DemoReviewRequest}
        options={{
          title: 'Review Request',
          headerRight: () => null,
          gestureEnabled: false,
        }}
      />
      <RootStack.Screen
        name={ROUTES.DEMO_REQUEST_DETAIL}
        component={DemoRequestDetail}
        options={{
          title: 'Request Detail',
          headerRight: () => null,
        }}
      />
      {/** Screen related to farmer 360 */}
      {Object.keys(routesFarmer360).map(route => (
        <RootStack.Screen
          key={route}
          name={route as FARMER_360_ROUTES}
          options={{
            ...routesFarmer360[route].options,
            title: localizedScreenTitle(routesFarmer360[route].options?.title),
          }}
          component={routesFarmer360[route].component}
        />
      ))}
      {Object.keys(routesKhetedge).map(route => (
        <RootStack.Screen
          key={route}
          name={route as FARMER_360_ROUTES}
          options={{
            ...routesKhetedge[route].options,
            title: localizedScreenTitle(routesKhetedge[route].options?.title),
          }}
          component={routesKhetedge[route].component}
        />
      ))}
    </RootStack.Navigator>
  )
}
